import { useState } from "react";
import axiosClient from "../../api/api";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSpotifyLogin = async () => {
    setIsLoading(true);
    try {
      const response = await axiosClient.post("/auth/login");
      if (response.status === 200) {
        window.location.href = response.data.spotifyRedirectUrl;
      }
    } catch (error) {
      console.error("Login failed:", error);
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-dark">
      <div className="text-center mb-5 p-4">
        <h1 className="text-light mb-4">Welcome to LyngoTunes</h1>
        <p className="text-light mb-4">Learn languages through music</p>

        <p className="text-warning mt-3">
          <small>
            <i>
              Spotify Premium is required.
              <br />
              Also, please ensure you're not using private/incognito mode as it
              may interfere with Spotify login.
            </i>
          </small>
        </p>
      </div>
      <button
        className="btn btn-success btn-lg d-flex align-items-center"
        onClick={handleSpotifyLogin}
        disabled={isLoading}
      >
        {isLoading ? (
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          <i className="bi bi-spotify me-2"></i>
        )}
        Sign in with Spotify
      </button>
    </div>
  );
};

export default Login;
